<template>
  <div id="app">
    <!-- <b-navbar variant="primary" class="d-flex justify-content-center">
      <b-navbar-brand class="text-light font-weight-bold">捐款回報</b-navbar-brand>
      <b-navbar-brand class="text-light font-weight-bold">信用卡捐款</b-navbar-brand>
    </b-navbar> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      errorMessage: ""
    };
  }
};
</script>

<style lang="scss">
#app {
  @import "./assets/custom-vars.scss";
  font-family: $font-family;
  -webkit-font-smoothing: $set-webkit-font-smooth;
  -moz-osx-font-smoothing: $set-moz-osx-font-smooth;
  text-align: $text-align;
  color: $font-color;
  background-color: $bg-color;
  // Bootstrap and its default variables
  @import "../node_modules/bootstrap/scss/bootstrap";
  // BootstrapVue and its default variables
  @import "../node_modules/bootstrap-vue/src/index.scss";
  font-size: 1.2rem !important;

  .navbar-brand {
    font-size: 1.5rem !important;
  }
}
</style>
